import {memoize} from "lodash";
import {launchDarkly} from "utils/launchDarkly.ts";

const LOGIN_METHOD_COOKIE_NAME = "approval_login_method";
const LOGIN_METHOD_CONNECT = "CONNECT";
const LOGIN_METHOD_ODP = "ODP";

export const isConnectLogin = memoize(internal_isConnectLogin);

function internal_isConnectLogin() {
    const connectCookieLoginMethod = getLoginMethodFromCookies();
    if (connectCookieLoginMethod != null) {
        return connectCookieLoginMethod === LOGIN_METHOD_CONNECT;
    }
    if (launchDarkly.anonymousClient == null) {
        return false;
    }

    return launchDarkly.anonymousClient.variation("use-connect-login", false);
}

function getLoginMethodFromCookies() {
    const cookies = document.cookie.split(';').map(cookie => cookie.trim());
    const connectCookieExists = cookies.find(cookie => cookie.startsWith(`${LOGIN_METHOD_COOKIE_NAME}=`));
    if (connectCookieExists != null) {
        let parts = connectCookieExists.split('=');
        if (parts.length > 1) {
            const connectCookieLoginMethod = parts[1];
            if (LOGIN_METHOD_CONNECT === connectCookieLoginMethod || LOGIN_METHOD_ODP === connectCookieLoginMethod) {
                return connectCookieLoginMethod;
            }
        }
    }
    return null;
}
